import {
  FETCH_VARIETIES_SUCCESS,
  FETCH_VARIETIES_LOADING,
  FETCH_VARIETIES_ERROR,
  FETCH_VARIETIES_CACHE_SUCCESS
} from '../actions/types';

const mergeIntoCache = (cache, varietiesList) =>
  (varietiesList || []).reduce(
    (acc, variety) => {
      acc[variety.id] = variety;
      return acc;
    },
    { ...cache }
  );

export const initialState = {
  loading: false,
  error: null,
  data: [],
  // id -> variety map accumulated across all fetch scopes, used for display
  // resolution; pickers keep reading the scoped `data` list
  cache: {}
};

export const varieties = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VARIETIES_SUCCESS:
      return {
        ...initialState,
        cache: mergeIntoCache(state.cache, action.payload),
        data: action.payload
      };

    case FETCH_VARIETIES_LOADING:
      return {
        ...initialState,
        cache: state.cache || {},
        loading: true
      };

    case FETCH_VARIETIES_ERROR:
      return {
        ...initialState,
        cache: state.cache || {},
        error: action.error
      };

    case FETCH_VARIETIES_CACHE_SUCCESS: {
      // keep the state identity when nothing new arrives so cache-dependent
      // effects don't re-trigger in a loop
      const cache = state.cache || {};
      const hasNewEntries = (action.payload || []).some((variety) => {
        if (!variety?.id) {
          return false;
        }
        const cached = cache[variety.id];
        return !cached || cached.updated_at !== variety.updated_at || cached.name !== variety.name;
      });
      if (!hasNewEntries) {
        return state;
      }
      return {
        ...state,
        cache: mergeIntoCache(cache, action.payload)
      };
    }

    default:
      return state;
  }
};
